import { css } from '@emotion/css';

export const canvas = css`
  label: item-label-canvas;
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
